/* ------------------------------------------------------------
 * UC REBRAND 2026 — interactions
 * Cursor reticle, scroll reveals, wrecking ball impact.
 * Loaded deferred from snippets/stylesheets.liquid.
 * ---------------------------------------------------------- */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Cursor reticle ----------
   * Only on real pointer devices. Never on touch, never under reduced
   * motion — replacing the system cursor is hostile if you can't track it. */
  function initCursor() {
    if (!finePointer.matches || reduced.matches) return;
    if (document.querySelector('.uc-cursor')) return;

    var el = document.createElement('div');
    el.className = 'uc-cursor';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<svg viewBox="0 0 48 48" width="48" height="48">' +
      '<circle class="uc-cursor__ring" cx="24" cy="24" r="13" fill="none" stroke-width="1.5"/>' +
      '<circle class="uc-cursor__dot" cx="24" cy="24" r="2"/>' +
      '<path class="uc-cursor__tick" d="M24 2v9M24 37v9M2 24h9M37 24h9" stroke-width="1.5"/>' +
      '</svg>';
    document.body.appendChild(el);
    document.documentElement.classList.add('uc-cursor-on');

    var tx = window.innerWidth / 2;
    var ty = window.innerHeight / 2;
    var cx = tx;
    var cy = ty;
    var running = false;

    function frame() {
      cx += (tx - cx) * 0.22;
      cy += (ty - cy) * 0.22;
      el.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0) translate(-50%,-50%)';
      if (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) {
        requestAnimationFrame(frame);
      } else {
        running = false;
      }
    }

    document.addEventListener(
      'pointermove',
      function (e) {
        if (e.pointerType !== 'mouse') return;
        tx = e.clientX;
        ty = e.clientY;
        el.classList.add('is-visible');
        if (!running) {
          running = true;
          requestAnimationFrame(frame);
        }
      },
      { passive: true }
    );

    document.addEventListener('pointerdown', function () {
      el.classList.add('is-down');
    });
    document.addEventListener('pointerup', function () {
      el.classList.remove('is-down');
    });
    document.addEventListener('mouseleave', function () {
      el.classList.remove('is-visible');
    });

    var interactive = 'a,button,summary,label,input,select,textarea,[role="button"],[tabindex]:not([tabindex="-1"])';
    document.addEventListener(
      'pointerover',
      function (e) {
        var t = e.target;
        if (t && t.closest && t.closest(interactive)) el.classList.add('is-active');
      },
      { passive: true }
    );
    document.addEventListener(
      'pointerout',
      function (e) {
        var t = e.target;
        if (t && t.closest && t.closest(interactive)) el.classList.remove('is-active');
      },
      { passive: true }
    );
  }

  /* ---------- Scroll reveals ----------
   * Applied to whole section wrappers rather than their children: sections are
   * block-level, so translating them can't break a grid or flex layout inside.
   * The first content section is skipped so nothing above the fold animates in. */
  function initReveals() {
    if (!('IntersectionObserver' in window)) return;

    var main = document.querySelector('#MainContent');
    if (!main) return;

    var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
    if (!sections.length) return;

    sections.forEach(function (section, i) {
      if (i === 0) return;
      if (section.hasAttribute('data-uc-no-reveal')) return;
      section.classList.add('uc-reveal');
    });

    if (reduced.matches) {
      sections.forEach(function (s) {
        s.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    sections.forEach(function (s) {
      if (s.classList.contains('uc-reveal')) io.observe(s);
    });
  }

  /* ---------- Wrecking ball ----------
   * The swing itself is pure CSS. This only adds the impact on click, which is
   * skipped under reduced motion. */
  function initWreckingBall() {
    var rigs = document.querySelectorAll('[data-uc-wrecking-ball]');
    if (!rigs.length) return;

    Array.prototype.forEach.call(rigs, function (rig) {
      var ball = rig.querySelector('.uc-wb__ball');
      if (!ball || reduced.matches) return;
      if (rig.dataset.ucBound === 'true') return;
      rig.dataset.ucBound = 'true';

      ball.addEventListener('click', function () {
        if (rig.classList.contains('is-impact')) return;
        rig.classList.add('is-impact');
        window.setTimeout(function () {
          rig.classList.remove('is-impact');
        }, 900);
      });
    });
  }

  function boot() {
    try {
      initCursor();
    } catch (e) {
      /* a decorative cursor must never take the page down */
    }
    try {
      initReveals();
    } catch (e) {}
    try {
      initWreckingBall();
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor re-renders sections in place, so re-run after each one. */
  document.addEventListener('shopify:section:load', function () {
    try {
      initReveals();
    } catch (e) {}
    try {
      initWreckingBall();
    } catch (e) {}
  });
})();
